export const fireGtagEvent = (eventName, redirectUrl) => {
  if (typeof window !== "undefined" && window.gtagSendEvent) {
    window.gtagSendEvent(eventName, redirectUrl);
  }
};
